module.exports = __webpack_public_path__ + "img/senar.0b4e7a4e.png";